import React, {useMemo, useState} from 'react';
import {Button, Card, Descriptions, Flex, Input, List} from "antd";
import {LoadingOverlay} from "../../launcher/common/loading/component";
import axios, {AxiosResponse} from "axios";
import {useQuery} from "react-query";
import {Page, UserSummary} from "../../commons/data/types";
import {UndoOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {Label} from "../../commons/translations/Label";

const {Search} = Input;

export const UsersAdministration: React.FC = () => {
    const {t} = useTranslation();
    const [filter, setFilter] = useState('');
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(2);

    const {data, isLoading, error} = useQuery<Page<UserSummary>>({
        queryKey: ['users', filter, page, pageSize],
        queryFn: () => axios.get<any, AxiosResponse<Page<UserSummary>>>(`/api/admin/users?filter=${filter}&page=${page}&size=${pageSize}`)
            .then(resp => resp.data),
    });

    const onSearch = (value: string) => {
        setFilter(value);
        setPage(0);
    };

    const onReset = () => {
        setFilter('');
        setPage(0);
    }

    const canReset = useMemo<boolean>(() => !!filter && filter !== '', [filter]);

    if (isLoading) {
        return <LoadingOverlay working={isLoading} />;
    }

    if (error) {
        return <div><Label trl="userAdmin.errors.fetch" /></div>;
    }

    return (
        <div id={"container"}>
            <Flex justify={"start"} align={"center"} vertical={false} style={{marginBottom: '16px'}}>
                <Search
                    placeholder={t("userAdmin.search.placeholder")}
                    onSearch={onSearch}
                    enterButton
                    style={{marginInlineEnd:'3px'}}
                />
                <div >
                    <Button icon={<UndoOutlined />} onClick={onReset} disabled={!canReset}/>
                </div>
            </Flex>
            <List
                grid={{gutter: 16, xs: 1, sm: 2, md: 3, lg: 4, xl: 4, xxl: 6}}
                dataSource={data?.content || []}
                pagination={{
                    onChange: (page, pageSize) => {
                        setPage(page - 1);
                        setPageSize(pageSize);
                    },
                    current: page + 1,
                    pageSize: pageSize,
                    total: data?.totalElements,
                    position: 'both',
                    showSizeChanger: true,
                }}
                renderItem={user => (
                    <List.Item>
                        <Card title={user.name} style={{marginTop:'3px'}}>
                            <Descriptions column={1} size="small" bordered>
                                <Descriptions.Item label={<Label trl="userAdmin.table.nickname" />}>{user.nickname}</Descriptions.Item>
                                <Descriptions.Item label={<Label trl="userAdmin.table.email" />}>{user.email}</Descriptions.Item>
                                <Descriptions.Item label={<Label trl="userAdmin.table.cellphone" />}>{user.cellphone}</Descriptions.Item>
                                <Descriptions.Item label={<Label trl="userAdmin.table.verified" />}>{user.verified ? t('common.yes') : t('common.no')}</Descriptions.Item>
                                <Descriptions.Item label={<Label trl="userAdmin.table.admin" />}>{user.isAdmin ? t('common.yes') : t('common.no')}</Descriptions.Item>
                            </Descriptions>
                        </Card>
                    </List.Item>
                )}
            />
        </div>
    );
};
